module.exports = __webpack_public_path__ + "static/business_strategy-209fb000cb31e73e015fc35abe29a600.jpg";